module.exports = __webpack_public_path__ + "img/04294ef.svg";